import axios, { AxiosResponse } from "axios";
import { api } from "../../data/urls";
import returnAuthHeaderForAJAX from "../auth/returnAuthHeaderForAJAX";
import { WebsitesItem } from "../../store/websites/types";

type IncrementAgentInstallsAsync = (payload: {
  accessToken: string;
  agentId: string;
}) => Promise<AxiosResponse<any>>;

export const incrementAgentInstallsAsync: IncrementAgentInstallsAsync = ({
  accessToken,
  agentId,
}) => {
  return new Promise((resolve, reject) => {
    const apiUrl = `${api.meta.incrementAgentInstallCount}?agent_id=${agentId}`;
    axios
      .get(apiUrl, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
